import axios from "axios";
import compose from "ramda/src/compose";
import queryString from "query-string";
import * as Auth from "services/network/auth";
import * as Routes from "services/network/routes";
import { bypass } from "services/utils/fn";
import { extractResponseData } from "services/network/endpoint";
import { logout } from "services/state/actions";
import ENV from "../../../../../envProperties";

window.log("process.env", process.env);

const PROTOCOL = "https";
const HOST = ENV.API_PORTAL;

const HTTP_REQUEST_HEADER = {
  "Accept-Language": "pt-BR",
  "Content-Type": "application/json",
};

export const BASE_URL = `${PROTOCOL}://${HOST}/${Routes.PORTAL}`;

const instance = axios.create({
  baseURL: BASE_URL,
  headers: HTTP_REQUEST_HEADER,
});

const interceptors = { request: [], response: [] };

interceptors.request.push({
  success: (unused, request) => {
    const sessionHeaders = Auth.getSessionHeaders();

    request.headers = { ...request.headers, ...sessionHeaders };

    const { baseURL, params, url } = request;

    if (request.download) {
      let downloadUrl = `${baseURL}${url}?${queryString.stringify(params)}`;

      window.log("interceptors.request.success download", { downloadUrl });
      window.location = downloadUrl;

      return false;
    }

    return request;
  },
  error: (unused, error) => {
    Promise.reject(error);
  },
});

interceptors.response.push({
  success: (unused, response) => {
    if (!response.data.resultData) return response;

    return compose(
      bypass(({ customerKey }) => Auth.setCustomer(customerKey)),
      extractResponseData,
      bypass(Auth.setAuthorization)
    )(response);
  },
  error: ({ dispatch }, error) => {
    if (error.response && error.response.status === 401) {
      dispatch(logout());
    }
    return Promise.reject(error);
  },
});

export default { client: instance, options: { interceptors } };



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/portal.js